<template>
  <div class="mt-3">
    <VideoInputSlider
      v-if="duration"
      v-model:model="modelProxy"
      v-model:active="activeProxy"
      :duration="duration"
    />
    <div class="flex gap-2 mt-2 justify-between" :class="[opacityClass]">
      <button
        class="text-xs font-semibold text-white bg-blue-450 rounded px-2 py-1"
        :disabled="!activeProxy || !duration"
        @click="setPoint('start')"
      >
        Set start
      </button>
      <button
        class="text-xs font-semibold text-white bg-blue-450 rounded px-2 py-1"
        :disabled="!activeProxy || !duration"
        @click="setPoint('end')"
      >
        Set end
      </button>
    </div>
  </div>
</template>

<script>
import VideoInputSlider from "../VideoInputSlider"

export default {
  name: 'AppearanceRange',
  components: {
    VideoInputSlider
  },
  props: {
    model: {
      type: Array,
      default () {
        return []
      }
    },
    active: {
      type: Boolean,
      default () {
        return true
      }
    },
    duration: {
      type: Number,
      required: true
    },
    previewCurrentTime: {
      type: Number,
      default () {
        return 0
      }
    },
    getPreviewCurrentTime: {
      type: Function,
      default () {
        return null
      }
    }
  },
  emits: ['update:model', 'update:active'],
  computed: {
    modelProxy: {
      get () {
        return this.model
      },
      set (val) {
        this.$emit('update:model', val)
      }
    },
    activeProxy: {
      get () {
        return this.active
      },
      set (val) {
        this.$emit('update:active', val)
      }
    },
    opacityClass () {
      return this.activeProxy ? 'opacity-100' : 'opacity-50'
    }
  },
  methods: {
    setPoint (point) {
      const duration = Number(this.duration || 0)
      const sourceTime = typeof this.getPreviewCurrentTime === 'function'
        ? this.getPreviewCurrentTime()
        : this.previewCurrentTime
      const clampedTime = this.clampTime(sourceTime, duration)
      const existing = Array.isArray(this.modelProxy) && this.modelProxy.length === 2
        ? this.modelProxy.slice(0)
        : [0, duration]
      if (point === 'start') {
        existing[0] = clampedTime
        if (existing[1] < existing[0]) {
          existing[1] = existing[0]
        }
      } else {
        existing[1] = clampedTime
        if (existing[0] > existing[1]) {
          existing[0] = existing[1]
        }
      }
      this.modelProxy = existing
    },
    clampTime (time, duration) {
      const numeric = Number(time || 0)
      const max = duration > 0 ? duration : numeric
      const clamped = Math.max(0, Math.min(numeric, max))
      return Number(clamped.toFixed(2))
    }
  }
}
</script>

<style scoped>
</style>
